// extracted by mini-css-extract-plugin
module.exports = {"input":"Datepicker_input__KdjEf","bordered":"Datepicker_bordered__Q4HZH","container":"Datepicker_container___UnaI","label":"Datepicker_label__WZJYl"};